import React from 'react';
import ScoutingInvitesCard from "./components/ScoutingInvitesCard";
import {Col, Row} from "react-bootstrap";
import SimpleScrollbar from "../../../ui/custom_scrollbars/SimpleScrollbar";
import Pagination from "../../../ui/pagination/Pagination";

const ScoutingInvites = (props) => {
    return (
        <div className="scouting-invites">
            <SimpleScrollbar className="scouting-scroll">
                <Row>
                    {
                        Array.from(Array(25).keys()).map(function (item, index) {
                            return (
                                <Col xs={12} md={6} xl={4}>
                                    <ScoutingInvitesCard />
                                </Col>
                            )
                        })
                    }
                </Row>
            </SimpleScrollbar>
            <Pagination
                currentPage="1"
                pageSize="30"
                totalSize="60"
                defaultCurrentPage="1"
                // handleSizePerPageChange={handleSizePerPageChange}
                // handlePageChange={handlePageChange}
            />
        </div>
    )
}

export default ScoutingInvites;
